<!-- 
	This is the Dashboards default page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>

    <div>

        <!-- Orders List header -->
        <a-row type="flex" :gutter="24">
            <a-col :span="6" class="mb-24">
                <label style="margin-right: 15px"><strong>Tanggal</strong></label>
                <a-dropdown :trigger="['click']">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        {{ filterDateText }}
                        <a-icon class="ml-5" type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                        <a-menu-item key="0" @click="setFilterTanggal('this_day')">Hari Ini</a-menu-item>
                        <a-menu-item key="1" @click="setFilterTanggal('this_week')">Minggu Ini</a-menu-item>
                        <a-menu-item key="2" @click="setFilterTanggal('this_month')">Bulan Ini</a-menu-item>
                        <a-menu-item key="3" disabled style="cursor: pointer">
                            <div style="color: #595959; margin-bottom: 5px">Tanggal</div>
                            <a-date-picker style="width: 140px" placeholder="Tanggal Awal" @change="setTanggalAwal"></a-date-picker>
                            <a-date-picker style="width: 140px; margin-left: 5px" placeholder="Tanggal Akhir" @change="setTanggalAkhir"></a-date-picker>
                        </a-menu-item>

                    </a-menu>
                </a-dropdown>

            </a-col>
            <a-col :span="12" class="mb-24" style="display: none">
                <label style="margin-right: 15px"><strong>Status</strong></label>
                <a-dropdown :trigger="['click']">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        {{ filterStatusMap[filterStatus] }}
                        <a-icon class="ml-5" type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                        <a-menu-item :key="0" @click="setFilterStatus('all')">Semua</a-menu-item>
                        <a-menu-item :key="i + 1" @click="setFilterStatus(status.code)" v-for="(status, i) in statusMap">{{ status.description }}</a-menu-item>
                    </a-menu>
                </a-dropdown>

            </a-col>
            <a-col :span="10" class="mb-24">
                <label style="margin-right: 15px"><strong>DPJP</strong></label>

                <a-select style="width: 70%;" v-model:value="dpjp_id" placeholder="- Pilih DPJP -" show-search
                          :filter-option="filterOptions"
                          :options="dpjps">
                </a-select>

            </a-col>
            <a-col :span="8" class="mb-24">
                <label style="margin-right: 15px"><strong>Klinik</strong></label>

                <a-select style="width: 70%;" v-model:value="department_id" placeholder="- Pilih DPJP -" show-search
                          :filter-option="filterOptions"
                          :options="departments">
                </a-select>

            </a-col>
        </a-row>
        <!-- / Orders List header -->

        <!-- Orders List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">

            <div style="position: absolute; left: 10px; top: 10px; z-index: 10; display: flex">
                <a-button @click="getData()" class="no-shadow">
                    <a-icon type="reload"></a-icon>
                </a-button>

                <download-excel
                    class="ant-btn ant-btn-default ml-5 no-shadow"
                    style="display: flex; align-items: center"
                    :data="formattedData"
                    :fields="{
                        'No': 'no',
                        'Status': 'status',
                        'Jumlah': 'count',
                    }"
                    worksheet="My Worksheet"
                    name="Evaluasi.xls"
                >
                    Export Excel
                </download-excel>
            </div>

            <!-- Orders table -->
            <a-table style="margin-top: 40px"
                     :columns="columns"
                     :data-source="formattedData"
                     :pagination="false"
                     rowKey="no"
            >

                <template slot="id" slot-scope="no">#{{ no }}</template>

                <template slot="jumlah" slot-scope="row">
                    <div class="count-container">
                        <div class="count-bar" :style="'width: ' + getBarWidth(row) + 'px'">
                            <div class="bar-popup">{{ getBarPercent(row) }} %</div>
                        </div>
                        <div class="count-text">{{ row.count }}</div>
                    </div>
                </template>

                <template #footer>
                    <div class="table-footer">
                        <div>Total</div>
                        <div class="flex-fill"></div>
                        <div>{{ data.length }}</div>
                    </div>
                </template>

            </a-table>
            <!-- / Orders table -->

        </a-card>
        <!-- / Orders List card -->

    </div>

</template>

<script>

import BookingApi from "../../../repository/api/BookingApi";
import {dateFormatIndo, dateFormatIndoWithDay, dateOnlyHourMinute} from "../../../utils/Extenstion";
import SettingRepository from "../../../repository/SettingRepository";
import {BASE_URL_API} from "../../../utils/Config";
import DpjpApi from "../../../repository/api/DpjpApi";

// Table columns
const columns = [
    {
        title: 'No',
        dataIndex: 'no',
        sorter: (a, b) => a.no - b.no,
        sortDirections: ['ascend', 'descend'],
        scopedSlots: { customRender: 'id'},
    },
    {
        title: 'Status',
        sorter: (a, b) => a.status_num - b.status_num,
        sortDirections: ['ascend', 'descend'],
        dataIndex: 'status',
    },
    {
        title: 'Jumlah',
        sorter: (a, b) => a.count - b.count,
        sortDirections: ['ascend', 'descend'],
        scopedSlots: { customRender: 'jumlah'},
        align: 'right'
    },
]

export default {
    name: "EvaluasiBooking",

    data() {
        return {
            columns,

            data: [],
            statusMap: [],
            filterStatusMap: {},

            filterDateText: SettingRepository.get("Evaluasi", "filterDateText") ?? 'Hari Ini',
            filterDateValue: SettingRepository.get("Evaluasi", "filterDateValue") ?? 'this_day',
            filterDateStart: SettingRepository.get("Evaluasi", "filterDateStart") ?? '',
            filterDateEnd: SettingRepository.get("Evaluasi", "filterDateEnd") ?? '',
            filterStatus: SettingRepository.get("Evaluasi", "filterStatus") ?? 'all',
            query: SettingRepository.get("Evaluasi", "filterQuery") ?? '',

            dpjps: [],
            dpjp_id: '',

            department_id: '',
        }
    },

    async mounted() {
        await this.getStatus()
        await this.$store.dispatch('apiData/getDepartment')

        this.getData()
        this.getDpjp()
    },

    computed: {
        formattedData() {
            const counts = {}

            const create = (status) => {
                if (!counts[status])
                    counts[status] = 0
            }

            for (const r of this.data) {
                // if (['0-init', '1-accepted', '1-canceled', '1-late-canceled', '2-accepted', '3-admitted', '3-case-rejected', '5-aborted', '5-done'].includes(r.trx_status)) {
                //     create(r.trx_status)
                //     counts[r.trx_status]++
                // }
                // // else if (['3-opened', '3-request'].includes(r.working_format_status)) {
                // //     create(r.working_format_status)
                // //     counts[r.working_format_status]++
                // // }
                // else if (['3-indicated', '4-request', '4-accepted', '4-rejected', '4-reordered'].includes(r.trx_status)) {
                //     create(r.trx_status)
                //     counts[r.trx_status]++
                // }
                // else {
                    create(r.trx_status)
                    counts[r.trx_status]++
                // }
            }

            return Object.keys(counts)
                .map(x => {
                    const status = this.statusMap.find(y => y.code === x)

                    return {
                        status_id: x,
                        count: counts[x],
                        status_num: status?.order ?? 0,
                        status: status?.description ?? 'Belum Booking DPJP'
                    }
                })
                .sort((a, b) => a.status_num - b.status_num)
                .map((x, i) => ({
                    ...x,
                    no: i + 1,
                }))
        },

        departments() {
            return [{
                value: '',
                label: 'Semua'
            }, ...this.$store.getters['apiData/department'].map(x => ({
                value: x.id,
                label: x.nama_departemen
            }))]
        },

        baseUrl() {
            return BASE_URL_API
        },
    },

    methods: {
        async getStatus() {
            try {
                this.statusMap = await BookingApi.getStatus()
            }
            catch (e) {
                this.$swal({
                    icon: e.severity || "error",
                    title: (e.severity || "error").toUpperCase(),
                    text: e.message,
                })
            }

            const m = { 'all': 'Semua' }

            for (const s of this.statusMap) {
                m[s.code] = s.description
            }

            this.filterStatusMap = m
        },

        getData() {
            const query = {
                date: this.filterDateValue,
                status: this.filterStatus,
            }

            if (this.dpjp_id)
                query['dpjp_code'] = this.dpjp_id

            if (this.department_id)
                query['departement_code'] = this.department_id

            BookingApi.getEvaluasi(query)
                .then((response) => {
                    this.data = response
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    });
                })
        },

        getDpjp() {
            DpjpApi.get()
                .then((response) => {
                    this.dpjps = [{
                        value: '',
                        label: 'Semua'
                    }, ...response.map(x => ({
                        value: x.id,
                        label: x.nama
                    }))]
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        setFilterTanggal(id) {
            this.filterDateValue = id
            const dateTexts = {
                'this_day': 'Hari Ini',
                'this_week': 'Minggu Ini',
                'this_month': 'Bulan Ini',
            }

            this.filterDateText = dateTexts[id]
            this.getData()
        },

        setFilterStatus(id) {
            this.filterStatus = id
            this.getData()
        },

        setTanggalAwal(date, dateString) {
            this.filterDateStart = dateString
            this.setTanggal()
            this.getData()
        },

        setTanggalAkhir(date, dateString) {
            this.filterDateEnd = dateString
            this.setTanggal()
            this.getData()
        },

        setTanggal() {
            if (this.filterDateStart) {
                this.filterDateText = dateFormatIndo(this.filterDateStart)
                this.filterDateValue = this.filterDateStart

                if (this.filterDateEnd) {
                    this.filterDateText += ' - ' + dateFormatIndo(this.filterDateEnd)
                    this.filterDateValue += ' ' + this.filterDateEnd
                }
            }
            else {
                this.filterDateText = "Hari Ini"
                this.filterDateValue = "this_day"
            }
        },

        statusByCode(code) {
            if (code === 'all')
                return "Semua"

            const s = this.statusMap.find(x => x.code === code)
            return s ? s.description : '-'
        },

        formatTanggal(row) {
            return dateFormatIndoWithDay(row.booking_date) + ' ' + dateOnlyHourMinute(row.dental_unit_time)
        },

        getBarWidth(row) {
            return Math.floor(this.data.length ? row.count * window.innerWidth / (this.data.length * 2) : 0)
        },

        getBarPercent(row) {
            return (this.data.length ? row.count * 100 / this.data.length : 0).toFixed(1)
        },

        filterOptions(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
    },

    watch: {
        filterDateText: function (n, o) {
            SettingRepository.save("Evaluasi", "filterDateText", n)
        },

        filterDateValue: function (n, o) {
            SettingRepository.save("Evaluasi", "filterDateValue", n)
        },

        filterDateStart: function (n, o) {
            SettingRepository.save("Evaluasi", "filterDateStart", n)
        },

        filterDateEnd: function (n, o) {
            SettingRepository.save("Evaluasi", "filterDateEnd", n)
        },

        filterStatus: function (n, o) {
            SettingRepository.save("Evaluasi", "filterStatus", n)
        },

        dpjp_id() {
            this.getData()
        },

        department_id() {
            this.getData()
        },
    }
};
</script>

<style lang="scss" scoped>

.table-footer {
    display: flex;
    font-weight: bold;
    padding: 0 10px;
}

.flex-fill {
    flex: 1;
}

.count-container {
    position: relative;
    overflow: visible;
    padding: 5px;

    &:hover .count-bar .bar-popup {
        opacity: 1;
    }

    .count-text {
        font-weight: bold;
        color: grey;
        position: relative;
    }

    .count-bar {
        background: rgba(81, 166, 211, 0.8);
        border: 1px solid #387091;
        border-radius: 3px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        overflow: visible;

        .bar-popup {
            display: flex;
            align-items: center;
            justify-content: end;
            position: absolute;
            top: 0;
            right: calc(100% + 7px);
            min-width: 100px;
            bottom: 0;
            font-weight: bold;
            color: #1e5475;
            opacity: 0;
            transition: opacity 0.1s;
        }
    }
}

</style>
